import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faRss, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { 
  faXTwitter,
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faYoutube,
  faPinterestP,
  faSnapchatGhost
 } from '@fortawesome/free-brands-svg-icons';
import MobileFooter from "./MobileFooter";
import "./Footer.css"
import FooterDetails from "./FooterDetails";

const Footer = (props) => {
  const [socialLinks, setSocialLinks] = useState([])
  const [footerDetailsPage, setFooterDetailsPage] = useState('')
  const [toggleFooterDetails, setToggleFooterDetails] = useState(false);


  useEffect(() => {
    let socialLinks = [
      [faFacebookF, "https://www.facebook.com/CDC", "facebook"],
      [faXTwitter, "https://twitter.com/CDCgov", "twitter/x"],
      [faInstagram, "https://www.instagram.com/CDCgov", "instagram"],
      [faLinkedinIn, "https://www.linkedin.com/company/centers-for-disease-control-and-prevention", "linked in"],
      [faYoutube, "https://www.youtube.com/cdc", "youtube"],
      [faPinterestP, "https://www.pinterest.com/cdcgov", "pinterest"],
      [faSnapchatGhost, "https://www.snapchat.com/add/cdcgov", "snapchat"],
      [faRss, "https://www.cdc.gov/rss", "rss"]
    ]

    setSocialLinks(socialLinks)
  }, [])

  const onClickFooterDetails = (pageTitle) => {
    if (pageTitle === footerDetailsPage && toggleFooterDetails) {
      setToggleFooterDetails(false);
      setFooterDetailsPage('');
    } else {
      setFooterDetailsPage(pageTitle);
      setToggleFooterDetails(true);
    }
  }

  const onKeyDown = (event, pageTitle) => {
    if (event.key === 'Enter' && (event.target.innerText === 'Contact Us' || event.target.innerText === 'About CDC' || event.target.innerText === 'Policies' || event.target.innerText === 'Archive')) {
      if (pageTitle === footerDetailsPage && toggleFooterDetails) {
        setToggleFooterDetails(false);
        setFooterDetailsPage('');
      } else {
        setFooterDetailsPage(pageTitle);
        setToggleFooterDetails(true);
      }
    }


  }
  return (
    <div className="margin-top-5">
      <MobileFooter classNames='display-block desktop:display-none' />
      <footer className={`usa-footer display-none desktop:display-block text-base-lightest ${props.className ? props.className : ''}`}>
        <nav aria-label="Footer navigation" >
          <section className="pad-l30 grid-row grid-gap bg-gray-70 padding-y-2 tablet:padding-x-2 desktop:padding-x-10" style={{ backgroundColor: '#005EA2'}}>
            <div className="grid-col-5 margin-y-auto">
              <ul className="usa-list usa-list--unstyled display-flex flex-row flex-justify" data-testid="contact">
                <li tabIndex={0} onClick={() => onClickFooterDetails('Contact Us')} onKeyDown={(event) => onKeyDown(event, 'Contact Us')}>
                  <div className="flex xsm-gap ai-c underline-hover">
                    <div>
                      Contact Us 
                    </div>
                    {
                      footerDetailsPage === 'Contact Us' ? (
                        <FontAwesomeIcon aria-label="hide-contact-us" icon={faAngleUp} />
                      ) : (
                        <FontAwesomeIcon aria-label="show-contact-us" icon={faAngleDown} />
                      )
                    }
                  </div>
                </li>
                <li tabIndex={0} onClick={() => onClickFooterDetails('About CDC')} onKeyDown={(event) => onKeyDown(event, 'About CDC')}>
                  <div className="flex xsm-gap ai-c underline-hover">
                    <div>
                      About CDC
                    </div>
                    {
                      footerDetailsPage === 'About CDC' ? (
                        <FontAwesomeIcon aria-label="hide-about" icon={faAngleUp} />
                      ) : (
                        <FontAwesomeIcon aria-label="show-about" icon={faAngleDown} />
                      )
                    }
                  </div>
                </li>
                <li tabIndex={0} onClick={() => onClickFooterDetails('Policies')} onKeyDown={(event) => onKeyDown(event, 'Policies')}>
                  <div className="flex xsm-gap ai-c underline-hover">
                    <div>
                      Policies 
                    </div>
                    {
                      footerDetailsPage === 'Policies' ? (
                        <FontAwesomeIcon aria-label="hide-policies" icon={faAngleUp} />
                      ) : (
                        <FontAwesomeIcon aria-label="show-policies" icon={faAngleDown} />
                      )
                    }
                  </div>
                </li>
                <li tabIndex={0} onClick={() => onClickFooterDetails('Archive')} onKeyDown={(event) => onKeyDown(event, 'Archive')}>
                  <div className="flex xsm-gap ai-c underline-hover">
                    <div>
                      Archive
                    </div>
                    {
                      footerDetailsPage === 'Archive' ? (
                        <FontAwesomeIcon aria-label="hide-archives" icon={faAngleUp} />
                      ) : (
                        <FontAwesomeIcon aria-label="show-archives" icon={faAngleDown} />
                      )
                    }
                  </div>
                </li>
              </ul>
            </div> 
          </section>
          {
            toggleFooterDetails && <FooterDetails title={footerDetailsPage}/>
          }
          <section className="flex aic sb container" style={{ backgroundColor: 'black'}}>
            <a href='/' className='flex ai-c'>
              <img src="/cdc-logo.svg" alt="CDC logo" className='cdc-img'/>
            </a>
            <ul className="usa-list usa-list--unstyled display-flex flex-row flex-justify-end">
              {socialLinks.map((social, index) => {
                return (
                  <li key={index} className="margin-x-1">
                    <a 
                      aria-label={social[2]}
                      className="socials-circle display-flex flex-align-center flex-justify-center bg-base margin-x-1 text-base-lightest border-base-lightest border-2px text-base-lightest"
                      href={social[1]}>
                      <FontAwesomeIcon icon={social[0]} />
                    </a>
                  </li>
                )
              })}
            </ul>
          </section>
        </nav>
      </footer>
    </div>
  )
}

export default Footer
